import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import React from 'react';
import {Icons} from '../assets/icons/Icons';
import {useAuthStore} from '../store';

export const HomeCards = () => {
  const {user} = useAuthStore();
  const settings = {
    overflow: 'visible',
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
  };

  return (
    <Slider {...settings} className=" gap-5 flex" style={{overflow: 'visible'}}>
      <Card
        totalBalance={`${user?.total_amount || 0}$`}
        currencySymbol=""
        currencyName="USD"
        currencyType="Main Account"
        lockedAmount="0"
      />
      <Card
        totalBalance={user?.mac_amount || 0}
        currencySymbol="MAC$"
        currencyName="MAC"
        currencyType="Crypto"
      />
    </Slider>
  );
};

export const Card = ({
  totalBalance = '0',
  currencySymbol = 'MAC$',
  currencyName = 'MAC',
  currencyType = 'Crypto',
  lockedAmount,
}) => {
  return (
    <div
      className="p-4 mx-1 fffg"
      // style={{
      //     maxWidth: "351px",
      //     backgroundImage: `url("images/store/card_bg.png")`,
      //     backgroundRepeat: "no-repeat",
      //     backgroundSize: "cover",
      //     overflow: "hidden",
      //     height: "240px",
      //     display: "flex",
      //     flexDirection: "column",
      //     justifyContent: "space-between",
      //     gap: "20px",
      // }}
      // style={{
      //     background: "rgba(44, 42, 209, 0.3)",
      //     border: "2px solid",

      //     borderImageSource:
      //         "linear-gradient(142.02deg, #6765FF 30.21%, rgba(0, 0, 0, 0.34) 79.43%)",
      //     backdropFilter: "blur(4px)",
      //     maxWidth: "351px",
      //     height: "249px",
      //     top: "131px",
      //     left: "20px",
      //     borderRadius: "24px",
      //     borderWidth: "2px",
      //     gap: "20px",
      // }}
    >
      {/* Header section */}
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0" style={{fontSize: '16px'}}>
          Total Balance
        </h5>
        <div>
          <Icons.Logo2 />
        </div>
      </div>

      {/* Card body with equal spacing */}
      <div className="d-flex flex-column" style={{gap: '20px'}}>
        {/* Balance section */}
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="fw-bold mb-0" style={{fontSize: '30px'}}>
            {currencySymbol} {totalBalance}
          </h1>

          {lockedAmount && (
            <div
              className="d-flex justify-content-between align-items-center rounded-4 p-1 px-2"
              style={{
                // backgroundColor: "#7674D0",
                height: '24px',
                background: 'rgba(118, 116, 208, 0.3)',
              }}
            >
              <Icons.LockAmount />
              <p
                className="p-0 m-0 ms-1"
                style={{
                  fontSize: '14px',
                  color: 'rgba(255, 255, 255, 0.5)',
                }}
              >
                {lockedAmount}$
              </p>
            </div>
          )}
        </div>

        {/* Currency info section */}
        <div
          className="d-flex justify-content-between align-items-center px-[24px] rounded-4 h-[64px]"
          style={{
            background: '#0000007D',
          }}
        >
          <div>
            <span
              style={{
                fontSize: '15px',
                color: 'rgba(237, 237, 253, 1)',
              }}
            >
              ({currencyName}) {currencyType}
            </span>
          </div>
          <div>
            <Icons.DollarSign />
          </div>
        </div>
      </div>
    </div>
  );
};
